import { AnketaQuestionRateHelp } from './AnketaQuestionRateHelp';

export default AnketaQuestionRateHelp;
